import { TeacherRouter } from '~teacher/context/RouterContext';

export function createWorkspaceQuizFragment({
  workspaceQuizId,
  workspaceId,
}: {
  workspaceQuizId: string;
  workspaceId: string;
}) {
  return `workspaces/${workspaceId}/quizzes/${workspaceQuizId}`;
}

export function navigateByQuizId({
  router,
  workspaceId,
  workspaceQuizId,
}: {
  router: TeacherRouter;
  workspaceQuizId: string;
  workspaceId: string;
}) {
  const newFragment = createWorkspaceQuizFragment({
    workspaceId,
    workspaceQuizId,
  });
  router.navigate(newFragment, { trigger: true });
}
